// extracted by mini-css-extract-plugin
export default {"container":"SegmentedControl_container__D1gws","item":"SegmentedControl_item__fuz0I","active":"SegmentedControl_active__ReL64"};